// extracted by mini-css-extract-plugin
module.exports = {"root":"AsideContainer_root__1XlMM","title":"AsideContainer_title__2EATk","description":"AsideContainer_description__2WxqH","widgets":"AsideContainer_widgets__1p1HV"};